if (!window.localizationDropdownInitialized) {
  window.localizationDropdownInitialized = true;

  document
    .querySelectorAll(".js-localization-dropdown__toggle")
    .forEach((button) => {
      button.addEventListener("click", function () {
        const expanded = this.getAttribute("aria-expanded") === "true";
        this.setAttribute("aria-expanded", !expanded);

        const menu = this.closest(".js-localization-dropdown").querySelector(
          ".js-localization-dropdown__menu"
        );
        if (!menu) {
          return;
        }

        menu.hidden = expanded;

        if (!expanded) {
          menu.style.display = "block";
        } else {
          menu.style.display = "none";
        }
      });
    });
}
